import {$, bool, datetime, InputType, Schema} from 'simpli-web-sdk'
import RiskAreaResponse from '@/model/response/RiskAreaResponse'

export default (model: RiskAreaResponse): Schema => ({
    cnpj: {
      content: model.responsavel ? $.filter.cpfOrCnpj(model.responsavel.cnpj) : '-',
      input: InputType.TEXT,
    },
    cepInicial: {
        content: model.cepInicial,
    },
    cepFinal: {
        content: model.cepFinal,
    },
    ativo: {
        content: bool(model.ativo),
    },
    notificarNoApp: {
        content: bool(model.notificarNoApp),
    },
    notificarNoPainel: {
        content: bool(model.notificarNoPainel),
    },
    dataCadastro: {
        content: datetime(model.dataCadastro),
    },
})
